import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {ChannelProfile} from "../shared/interfaces";
import {ChannelService} from "../shared/services/channel.service";
 import {AuthService} from "../shared/services/auth.service";
 
import {NbToastrService, NbGlobalPosition } from '@nebular/theme';


@Component({
  selector: 'app-channel-edit-page',
  templateUrl: './channel-edit-page.component.html',
  styleUrls: ['./channel-edit-page.component.scss']
})
export class ChannelEditPageComponent implements OnInit, OnDestroy {

  loadingCover: boolean = true;
  form: FormGroup;
  aSub$:Subscription;
  lSub$:Subscription;
  cSub$:Subscription;

  imageCoverPreview:any = '';
  imageAvatarPreview:any = '';
  imageThumbPreview:any = '';
  channel: ChannelProfile;

  uploadCover: any;
  deleteCover: boolean;

  uploadAvatar: any;
  deleteAvatar: boolean;

  uploadThumb: any;
  deleteThumb: boolean;

  validators: any;

  urlAvailable: boolean = true;
  showUrlAvailable: boolean = false;


  constructor(
     private channelService: ChannelService,
    private toastrService: NbToastrService,
    private authService: AuthService
  ) {

    this.validators = {
      url: "^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$" ,
      alias: "^[a-zA-Z0-9\_]+$"
    }; 
  }


    ngOnInit() {


      this.loadChannel()


  /*  this.form = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      password: new FormControl(null, [Validators.required, Validators.minLength(6)])
    }) */

  }

  loadChannel(){
    
    this.lSub$ = this.channelService.getOwn().subscribe((channel:ChannelProfile)=>{
      this.channel = channel
      this.loadingCover = false 
      this.imageCoverPreview = this.channel.cover_image
      this.imageAvatarPreview = this.channel.avatar_image
      this.imageThumbPreview = this.channel.thumb_image

	



      this.form = new FormGroup({ 
        title: new FormControl(this.channel.title, [Validators.required]),
        description: new FormControl(this.channel.description),
        url: new FormControl(this.channel.url, [Validators.required,Validators.pattern(this.validators.alias)]),
		//,Validators.pattern(this.validators.url)
        soc_facebook: new FormControl(this.channel.soc_facebook),
        soc_instagram: new FormControl(this.channel.soc_instagram),
        soc_twitter: new FormControl(this.channel.soc_twitter),
        soc_vk: new FormControl(this.channel.soc_vk),

        msg_whatsapp: new FormControl(this.channel.msg_whatsapp),
        msg_telegram: new FormControl(this.channel.msg_telegram),
        msg_viber: new FormControl(this.channel.msg_viber),

        site: new FormControl(this.channel.site)
      }) 

      
    })
    
    
  }

  ngOnDestroy(){
    if(this.aSub$){
      this.aSub$.unsubscribe()
    }

    if(this.lSub$){
      this.lSub$.unsubscribe()
    }
    if(this.cSub$){
      this.cSub$.unsubscribe()
    }


  }


  //urlAvailable


  onChangeImage(type:string, event:any){
 
      const file = event.target.files[0]
     
  
      const reader = new FileReader()
  
       
      reader.onload = () => {
        if(type === 'cover'){
            this.imageCoverPreview = reader.result
            this.uploadCover = file
            this.deleteCover = false
            
        }else  if(type === 'avatar') {
          this.imageAvatarPreview = reader.result
          this.uploadAvatar = file
          this.deleteAvatar = false

        }   if(type === 'thumb') {
          this.imageThumbPreview = reader.result
          this.uploadThumb = file
          this.deleteThumb = false


        }  
       // this.imagePreview = reader.result
      }
      reader.readAsDataURL(file)
   
  } 


  onUrlChange(url:string){
	 
	
	if(!this.form.get('url').errors){
		 
	
		if(url != this.channel.url){

			 if(this.cSub$){
     			 this.cSub$.unsubscribe()
    			}
	
			this.form.disable()
		 	this.cSub$ = this.channelService.checkUrlAvailable( url ).subscribe((available)=>{
			 
				this.urlAvailable = available
				this.showUrlAvailable = true
				this.form.enable()
			},()=>{

				this.form.enable()
			})

		} else {  this.showUrlAvailable = !this.urlAvailable }

        }   
 }



  downloadHtml(){

	if(this.channel.url){

		let text = `<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8">
    <title>Канал: ${this.channel.title}</title>
  </head>
  <body style="margin:0px;padding:0px;overflow:hidden">
    <iframe  src="https://livestream.ua/channel/${this.channel.url}?embed-channel=true" livestreamChannel allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="100%" width="100%"></iframe>
</body>
</html>
`;

	
	 this.saveTextAsFile(text, `${this.channel.url}.html`)


	}

 }



  submit() {
    
  /**/ if(this.form.invalid){
      return
    }  

    const channel:ChannelProfile = this.form.value;
 

    this.form.disable()
    this.aSub$ = this.channelService.update(
      channel,
      this.uploadCover,
      this.uploadAvatar,
      this.uploadThumb,
      this.deleteCover,
      this.deleteAvatar,
      this.deleteThumb
      ).subscribe((channel:ChannelProfile)=>{
         this.channel = channel

	this.authService.setNewPicture(this.channel.avatar_image)
	this.authService.setNewChannelUrl(this.channel.url)
	this.form.enable()	
	this.showUrlAvailable = false
 this.toastrService.show('','Налаштування збережені',{
          status: 'success',
	position: <NbGlobalPosition>'bottom-right'
        })
    }, error => {
      this.form.enable()
     // MaterialService.toast(error.error.message)
	 

	if(error.error?.unavailableAddress){
		this.urlAvailable = false
		this.showUrlAvailable = true
	}

 	this.toastrService.show('', (error.error?.unavailableAddress ? error.error.message : 'Сталася помилка сервера'),{
          status: 'danger',
	position: <NbGlobalPosition>'bottom-right'
        })
    })

  }


   saveTextAsFile (data, filename){

    if(!data) {
        console.error('Console.save: No data')
        return;
    }

    if(!filename) filename = 'file.txt'
	
	 

    var blob = new Blob([data], {type: 'text/plain'}),
        e    = document.createEvent('MouseEvents'),
        a    = document.createElement('a')
 

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        }
        else{
          var e = document.createEvent('MouseEvents'),
              a = document.createElement('a');

          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
         /* e.initEvent('click', true, false, window,
              0, 0, 0, 0, 0, false, false, false, false, 0, null); */
		e.initEvent('click')
          a.dispatchEvent(e);
        }
  }

}
